import { render, staticRenderFns } from "./AddZone.vue?vue&type=template&id=03961680&"
import script from "./AddZone.vue?vue&type=script&lang=js&"
export * from "./AddZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports